import { PurgeDataRequestResult } from '@airreading/common/data';

import { pluralize } from '@/lib/string-utils';

const rowsLabel = (rows: number) => `${rows.toLocaleString()} ${pluralize(rows, 'row', 'rows')}`;

export const PurgeResultSummary = ({ result }: { result: PurgeDataRequestResult }) => {
  const failed = result.status === 'error';

  return (
    <div className="w-full" data-testid="purge-result-summary">
      <h4 className="mb-1 text-sm font-bold">{failed ? 'Purge stopped' : 'Purge complete'}</h4>
      <p className={`mb-3 text-sm ${failed ? 'text-destructive' : 'text-gray-600'}`} data-testid="purge-result-message">
        {result.message}
      </p>
      <dl className="text-sm">
        {result.tables.map((table) => (
          <div
            key={table.table}
            className="flex items-baseline justify-between gap-4 border-b border-gray-100 py-1 last:border-b-0"
            data-testid={`purge-result-row-${table.table}`}
          >
            <dt className="font-mono">{table.table}</dt>
            <dd className="text-right">
              {table.status === 'complete' && (
                <span className="text-gray-600">
                  {rowsLabel(table.rowsDeleted ?? 0)}
                  {table.rowsDeleted !== table.rowsExpected && (
                    <span className="text-yellow-700"> (expected {table.rowsExpected.toLocaleString()})</span>
                  )}
                </span>
              )}
              {table.status === 'error' && <span className="text-destructive">{table.errorMessage}</span>}
              {table.status !== 'complete' && table.status !== 'error' && (
                <span className="text-gray-500">not attempted</span>
              )}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
